<template>
    <table id="tab" >
      <tr>
        <td 
          :colspan="hasChild ? model.children.length * 2 : 1"
          :class="{ extend: hasChild && model.extend }"
          
          >
  
          <div class="card" >
            <div class="title">{{ model.nickName }}
              <span v-if="model.nickName != '左区' && model.nickName != '右区'">
                <a @click="$emit('on-new', model)" >{{ model.user_id }}</a>
              </span>
            </div>
            <div>总盒数：<span style="font-weight: blod;font-size: 14px;">{{ model.count }}</span> </div>
            <div>本人购买：<span style="font-weight: blod;">{{ model.num }}</span></div>
   
            <div class="footer" v-if="model.nickName != '左区' && model.nickName != '右区'">
              <div @click="$emit('on-update', model,1)" v-if="model.resId!='root'">标记为左</div>
              <div @click="$emit('on-update', model,0)" v-if="model.resId!='root'">取消标记</div>
              <div @click="$emit('on-update', model,2)" v-if="model.resId!='root'">标记为右</div>
              
            </div>
            <div v-else  class="footer" >
              <div @click="$emit('on-clear', model)" style="margin: auto;">清除分区</div>
            </div>
          </div>
          <div class="extend_handle" v-if="hasChild" ><span @click="toggleExtend()"> {{ model.extend ?   '隐藏':'展开' }}</span></div>
        </td>
      </tr>
      <tr v-if="hasChild && model.extend">
        <td
          v-for="(item, index) in model.children"
          :key="index"
          colspan="2"
          class="child"
        >
          <!--跨层级监听事件 v-on="$listeners"（.native原生事件无效） -->
          <TreeChart   v-drag="{type:'name',obj:curObj}"  style="position: relative;"
      :style="'top:' + top + 'px;left:' + left + 'px;'" :isChild="isChild" :model="item" v-on="$listeners"/>
        </td>
      </tr>
    </table>
  </template>
  
  <script>
  export default {
    name: 'TreeChart',
    props: ['model',"isChild"],
    data(){
      return {
      
           /*当前对象*/
      curObj:this,
      left:0,
      top:0,
      }
    },
    computed: {
      hasChild () {
        return this.model.children && this.model.children.length
      }
    },
    directives: {
    /*拖动指令*/
    drag: {
      inserted: function(el, binding) {
        let self = this;
        el.onmousedown = function(event) {
          event = event || window.event;
          let diffX = event.clientX - el.offsetLeft;
          let diffY = event.clientY - el.offsetTop;

          /*鼠标移动*/
          document.onmousemove = function(event) {
            event = event || window.event;
            let moveX = event.clientX - diffX;
            let moveY = event.clientY - diffY;
            binding.value.obj.dragDiv(moveX,moveY,binding.value.type);
          };

          /*鼠标弹起*/
          document.onmouseup = function(event) {
            document.onmousemove = null;
            document.onmouseup = null;
          };
        };
      }
    }
  },
    methods: {
      toggleExtend () {
        this.model.extend = !this.model.extend
      },
    
    /*拖动赋值*/
    dragDiv(x, y,type) {
    
       if(type=='name'){
        this.left=x;
        this.top=y;
      }

    },
    }
    
  }
  </script>
  
  <style lang="scss">
  .card {
    background: rgb(227, 236, 247);
    border: 2px solid #ffffff;
    border-radius: 5px;
    margin: 0 auto;
    width: 200px;
    .title {
      padding: 10px 0;
      font-size: 12px;
    }
  
    .body {
      height: 100px;
      background: #ffffff;
      width: auto;
      margin: 0 15px;
    }
  
    .footer {
      display: flex;
      margin: 5px 15px;
      justify-content: space-between;
      div {
        font-size: 12px;
        color: rgb(20, 126, 192);
        cursor: pointer;
      }
    }
  }
  .extend_handle {
    cursor: pointer;
  }
  table {
    border-collapse: separate !important;
    border-spacing: 0 !important;
    td {
      position: relative;
      vertical-align: top;
      padding: 0 0 50px 0;
      text-align: center;
      &.extend {
        &::after {
          content: '';
          position: absolute;
          left: 50%;
          bottom: 18px;
          height: 30px;
          border-left: 2px dashed rgb(159, 186, 202);
          transform: translate3d(-1px, 0, 0);
        }
      }
      &.child {
        &::before {
          content: '';
          position: absolute;
          left: 50%;
          bottom: 100%;
          height: 15px;
          border-left: 2px dashed rgb(159, 186, 202);
          transform: translate3d(-1px, 0, 0);
        }
        // 横线
        &::after {
          content: '';
          position: absolute;
          left: 0;
          right: 0;
          top: -15px;
          border-top: 2px dashed rgb(159, 186, 202);
        }
        &:first-child:before,
        &:last-child:before {
          display: none;
        }
        &:first-child:after {
          left: 50%;
          height: 15px;
          border: 2px dashed;
          border-color: rgb(159, 186, 202) transparent transparent
            rgb(159, 186, 202);
          border-radius: 6px 0 0 0;
          transform: translate3d(1px, 0, 0);
        }
        &:last-child:after {
          right: 50%;
          height: 15px;
          border: 2px dashed;
          border-color: rgb(159, 186, 202) rgb(159, 186, 202) transparent
            transparent;
          border-radius: 0 6px 0 0;
          transform: translate3d(-1px, 0, 0);
        }
        &:first-child.child:last-child::after {
          left: auto;
          border-radius: 0;
          border-color: transparent rgb(159, 186, 202) transparent transparent;
          transform: translate3d(1px, 0, 0);
        }
      }
    }
  }
  </style>



// WEBPACK FOOTER //
// src/views/user/tree/part/TreeChart.vue